import { Component } from '@angular/core';
import { ThemeService } from '../../../../../services/theme.service';

@Component({
    selector: 'app-mdr-dashboards-banner',
    templateUrl: './mdr-dashboards-banner.component.html',
    styleUrls: ['./mdr-dashboards-banner.component.scss'],
    standalone: false,
})
export class MdrDashboardsBannerComponent {
    constructor(public themeService: ThemeService) {}

    public openDoc(type: 'new' | 'releases') {
        if (type == 'new') {
            window.open('https://www.bitdefender.com/blog/businessinsights/');
        } else {
            window.open('https://www.bitdefender.com/business/support/en/124809-484082-release-notes.html');
        }
    }
}
